<template>

  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat h-screen" style="background-color: #3F403E;">
    <div class="w-full">
      <div class="pb-5 flex flex-col items-center max-h-full">
        <img class="max-h-full object-contain w-4/12" src="@/assets/logo.png"/>
      </div>
      <h1 class="font-bold text-3xl w-full text-center text-white mt-5 pt-5" style="font-family: Martin;">MUCHAS GRACIAS POR INSCRIBIRSE A CAPER SHOW 2024</h1>
    </div>
  </header>

</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
  },
});
</script>